/**
 * Canonical news review status values
 */
export const NEWS_REVIEW_STATUS = {
  PENDING_REVIEW: 'PENDING_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  AUTO_INCLUDE: 'AUTO_INCLUDE',
  AUTO_REJECTED: 'AUTO_REJECTED',
}

/**
 * Confidence score thresholds that map to review statuses.
 *   0  – 39  - Very Low  - AUTO_REJECTED
 *   40 – 75  - Low       - PENDING_REVIEW
 *   76 – 100 - Below Threshold - AUTO_INCLUDE
 */
export const CONFIDENCE_THRESHOLDS = {
  VERY_LOW_MAX: 39,
  LOW_MAX: 75,
}

/**
 * Status values that the filter "All" includes
 */
export const ALL_REVIEW_STATUSES = [
  NEWS_REVIEW_STATUS.PENDING_REVIEW,
  NEWS_REVIEW_STATUS.REJECTED,
  NEWS_REVIEW_STATUS.APPROVED,
]
